export default __webpack_public_path__ + "static/media/Andrzej Gajewski.ba4392b5.jpg";